import { useState } from "react";
import { useParams } from "react-router-dom";
import createSchemaObject from "./utils/createSchemaObject";
import reduceIngredients from "./utils/reduceIngredients";
import reduceInstructions from "./utils/reduceInstructions";
import { createSectionsState } from "./utils/createSectionsState";
import { Helmet } from "react-helmet";
import Intro from "./Intro";
import Equipment from './Equipment';
import Settings from "./Settings";
import Ingredients from './Ingredients';
import Instructions from './Instructions';
import Notes from './Notes';
import './scss/Recipe.scss';
import './scss/Modal.scss';

function Recipe() {
  // get the recipe based on URL path
  const { recipeName } = useParams();
  const { recipe } = require(`./recipes/${recipeName}/recipe`);
  // destructure "recipe"
  const { intro, equipment, settings, ingredients, instructions, notes } = recipe;

  // track the current configuration of the recipe page
  const [config, setConfig] = useState({
    servings: settings.baseServingSize,
    units: 'us',
    filter: settings.filterInitialState
  })

  // reduced arrays based on config
  const ingredientsUpdated = reduceIngredients(ingredients, settings, config);
  const instructionsUpdated = reduceInstructions(ingredientsUpdated, instructions, settings, config);
  const sectionsState = createSectionsState(instructionsUpdated);

  // function passed to Settings that allows it to update the config
  function updateConfig(key, value) {
    setConfig({ ...config, [key]: value })
  }

  return (
    <>
    <Helmet>
      <title>{intro.title}</title>
      <script type="application/ld+json">{createSchemaObject(recipe)}</script>
    </Helmet>
    <div id="recipe-sidebar-container">
      <div id="recipe-container">
        <Intro intro={intro} />
        {recipe.equipment && <Equipment equipment={equipment} />}
        <Settings 
          config={config} 
          updateConfig={updateConfig}
          settings={settings}
        />
        
        <section id="ingredients-instructions-wrapper">
          <Ingredients ingredients={ingredientsUpdated} />
          <Instructions 
            instructions={instructionsUpdated}
            sectionsStateInit={sectionsState} 
          />
        </section>  

        {recipe.notes && <Notes notes={notes} />}
      </div>
      <div id="sidebar"><p>This is a prototype for demonstration purposes only.<br/><br/>Recipe is from <a href="https://cookwithdana.com/dak-galbi-stir-fry-spicy-chicken/#recipe" target="_blank">Cook with Dana</a></p></div>
    </div>
    </>
  );
}

export default Recipe;
